import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import useRoundup from '../../hooks/use-roundup';
import MODAL from '../../components/modal/modal';
import Scorecard from '../../partials/roundups/prepare/scorecard';
import ScheduledGoalList from '../../partials/goals/scheduled-goal-list';

export default function Roundup_Prepare() {
  const navigate = useNavigate();
  const roundup = useRoundup();
  const [pickerOpen, setPickerOpen] = useState(false);
  const [allGoals, setAllGoals] = useState([]);
  const [selected, setSelected] = useState([]);
  const [error, setError] = useState('');
  const [loadingGoals, setLoadingGoals] = useState(false);

  useEffect(() => { setSelected(roundup.goals.map(goal => goal._id)); }, [roundup.goals]);
  const openGoals = async () => {
    setPickerOpen(true);
    setLoadingGoals(true);
    setError('');
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_WEB_URL}api/goals/get-user-goals`, {}, { withCredentials: true });
      if (!Array.isArray(data.userGoals)) throw new Error();
      setAllGoals(data.userGoals);
      setSelected(roundup.goals.map(goal => goal._id));
    } catch { setError('Unable to load your goals. Close this window and try again.'); }
    finally { setLoadingGoals(false); }
  };
  const saveGoals = async event => {
    event.preventDefault();
    try {
      await roundup.changeGoals(allGoals.filter(goal => selected.includes(goal._id)));
      setPickerOpen(false);
    } catch { /* The shared save message keeps the draft available for retry. */ }
  };
  const begin = async () => {
    try { await roundup.persist(); navigate('/weekly-roundup-underway'); }
    catch { /* Displayed below; keep the user on the unsaved draft. */ }
  };

  if (roundup.loading) return <p role="status">Loading your roundup…</p>;
  if (roundup.error) return <div role="alert">{roundup.error} <button onClick={roundup.retry}>Try again</button></div>;
  if (!roundup.year) return <div><h1>Start your year first</h1><p>A year gives your weekly roundups their schedule.</p><Link to="/manage-year">Manage your year</Link></div>;

  return <>
    <div className="prepare-roundup">
      <h1>Planning Roundup {roundup.number}</h1>
      <p className="text-align--center">Week {roundup.number} of your year, starting {new Date(roundup.year.startDate).toLocaleDateString('en-GB')}.</p>
      {roundup.isCompleted && <p className="roundup-completed-notice">This roundup is complete and locked. <Link to="/weekly-roundup-underway">View your summary</Link></p>}
      {roundup.saveError && <p role="alert">{roundup.saveError} <button onClick={() => roundup.persist().catch(() => {})}>Try saving again</button></p>}
      {roundup.saving && <p role="status">Saving your roundup…</p>}
      <div className="row">
        <div className="col-md-6 col-12"><Scorecard items={roundup.items} onItemsChange={roundup.changeItems} isCompleted={roundup.isCompleted} /></div>
        <div className="col-md-6 col-12">
          <h2>Roundup Goals</h2>
          {roundup.goals.length ? <ScheduledGoalList goals={roundup.goals} readOnly /> : <p>No goals selected yet.</p>}
          {!roundup.isCompleted && <><button onClick={openGoals}>Choose goals</button><button className="btn-solid-gray pill" disabled={roundup.saving || !!roundup.saveError} onClick={begin}>Begin roundup</button></>}
        </div>
      </div>
      <MODAL isOpen={pickerOpen} onClose={() => setPickerOpen(false)}>
        <h2>Choose goals for your roundup</h2>
        {loadingGoals ? <p role="status">Loading goals…</p> : error ? <p role="alert">{error}</p> : <form onSubmit={saveGoals}>
          {allGoals.length ? allGoals.map(goal => <label className="roundup-goal-choice" key={goal._id}>
            <input type="checkbox" checked={selected.includes(goal._id)} onChange={() => setSelected(previous => previous.includes(goal._id) ? previous.filter(id => id !== goal._id) : [...previous, goal._id])} /> {goal.name}
          </label>) : <p>No goals yet. <Link to="/manage-goals">Add a goal</Link></p>}
          <button type="submit" disabled={roundup.saving}>Save selection</button>
        </form>}
        <button type="button" onClick={() => setPickerOpen(false)}>Cancel</button>
      </MODAL>
    </div>
    <ToastContainer />
  </>;
}
